var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerOutage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 317,
    viewBox: "0 0 366 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.559 158.896L183.301 0.796387L92.0401 158.901L0.671875 317H365.93L274.559 158.896ZM183.291 40.7998L257.24 168.899L331.271 297H35.3209L109.359 168.903L183.291 40.7998ZM171.101 137H194.801L190.301 217H175.701L171.101 137ZM193.001 247H173.001V227H193.001V247Z",
    fill: "#BF4F2A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOutage);
export default __webpack_public_path__ + "static/media/power_outage.502b8bd294746b5ac57eae6e75e6ac32.svg";
export { ForwardRef as ReactComponent };